import React, { useState } from 'react';
import Paragraph, { ParagraphProps } from 'antd/es/typography/Paragraph';
import { Tooltip } from 'antd';

const TooltipParagraph: React.FC<any> = ({ children, ellipsis, placement, ...props }) => {
  const [truncated, setTruncated] = useState(false);

  return (
    <Tooltip
      title={truncated ? children : undefined}
      color="white"
      overlayInnerStyle={{ color: 'black' }}
      placement={placement}
    >
      <Paragraph
        {...props}
        ellipsis={{ ...ellipsis, onEllipsis: setTruncated }}
      >
        <>{children}</>
      </Paragraph>
    </Tooltip>
  );
};

export default TooltipParagraph;
